import bilAPI from "../api";

export const uploadResultsToCheck = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/results/upload/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const publishResults = (body, params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/user_results/toggle_publish/`, body, {
          params: params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const exportTeamResultsExcel = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/teams/export_team_results/`, {}, { params: params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
